import { FormField } from "../../UI/DesignStandards";

const CreateAdditionalPrizeFundForm = ({
  onSubmit,
  onSave,
  description,
  setDescription,
  amount,
  setAmount,
  error,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col space-y-2">
        <label
          htmlFor="description"
          className="text-sm font-medium text-brand-charcoal"
        >
          Description
        </label>
        <FormField
          type="text"
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Enter prize fund description"
        />
      </div>

      <div className="flex flex-col space-y-2">
        <label htmlFor="amount" className="text-sm font-medium text-brand-charcoal">
          Amount (board total)
        </label>
        <p className="text-sm font-medium text-brand-charcoal">
          Added once to the prize fund. Not a per-bowler rate.
        </p>
        <div className="relative rounded-md shadow-sm">
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <span className="text-brand-muted sm:text-sm">$</span>
          </div>
          <FormField
            type="number"
            id="amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0.00"
            min="0"
            step="0.01"
            className="pl-7 pr-12"
          />
        </div>
      </div>

      {error && <div className="text-sm text-red-600">{error}</div>}
    </div>
  );
};

export default CreateAdditionalPrizeFundForm;
